import { Box, Container } from "@mui/material";

function PageWrapper(props) {
  return (
    <Container maxWidth={false}>
      <Box p="24px 0 24px" {...props} />
    </Container>
  );
}

export default PageWrapper;
